export enum TestPrefix {
  Display = 'display',
  Button = 'button',
  DragAndDrop = 'drag-and-drop',
  Input = 'input',
  Select = 'select',
  DatePicker = 'date-picker',
  Radio = 'radio',
  Checkbox = 'checkbox',
  Table = 'table',
  Tab = 'tab',
  Tag = 'tag',
  Modal = 'modal',
  Paging = 'paging',
}

export enum TestButtonAction {
  Submit = 'submit',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  ShowModal = 'show',
  CloseModal = 'close',
  Transition = 'transition',
  Download = 'download',
  Do = 'do',
}
export function dataTestID(prefix: TestPrefix, targetUIName: string, action: TestButtonAction = TestButtonAction.Do): string {
  if (prefix === TestPrefix.Button) {
    return `${prefix}-${action}-${targetUIName}`;
  } else {
    return `${prefix}-${targetUIName}`;
  }
}
